// Pick a product by typing a few letters: Unknown names and Vendor codes (decision 150) link with it.
import type { Item } from '@morales/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api';
import { packLabel } from '../format';
import { useDebounced } from '../hooks';
import { useLocale } from '../i18n';
import { qk } from '../queryClient';
import { Empty, QueryView, SearchBox } from './ui';

const PICKER_LIMIT = 30;

export function ItemPicker({ onPick, onCancel, busy, initial = '' }: { onPick: (item: Item) => void; onCancel: () => void; busy: boolean; initial?: string }) {
  const { t } = useLocale();
  const [q, setQ] = useState(initial);
  const term = useDebounced(q.trim());
  const list = useQuery({
    queryKey: qk.items(term),
    queryFn: ({ signal }) => api.items(term, signal),
    placeholderData: keepPreviousData,
  });
  return (
    <div className="picker">
      <div className="picker-head">
        <SearchBox value={q} onChange={setQ} autoFocus />
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          {t('cancel')}
        </button>
      </div>
      <QueryView query={list}>
        {(rows) => {
          const shown = rows.slice(0, PICKER_LIMIT);
          return shown.length === 0 ? (
            <Empty>{t('noResults')}</Empty>
          ) : (
            <ul className="list">
              {shown.map((item) => (
                <li key={item.id}>
                  <button type="button" className="row" onClick={() => onPick(item)} disabled={busy}>
                    <span className="row-main">
                      <span className="row-title">{item.name}</span>
                      <span className="row-sub">
                        {item.sku ? <span className="label">{item.sku}</span> : null}
                        {packLabel(item)}
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          );
        }}
      </QueryView>
    </div>
  );
}

